import TrainingDetail from "./Detail";
import TrainingList from "./List";

export { TrainingList, TrainingDetail };
